export default __webpack_public_path__ + "static/media/by-nc.9e3cfd3d.svg";